// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2cOuX","content":"ManualTimeModal_content__3jOQ9"};